// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3XPLM","inputDescription":"styles_inputDescription__1XvQq"};